import { hasConsent, onConsentChange, OSANO_CATEGORY } from '../consent.js'

const HUBSPOT_UTK_RETRY_DELAYS_MS = [250, 500, 1000, 2000, 4000, 8000]

export function readHubSpotUtk(cookie = document.cookie) {
  for (const part of cookie.split(';')) {
    const [name, ...valueParts] = part.trim().split('=')

    if (name === 'hubspotutk') {
      return valueParts.join('=').trim()
    }
  }

  return ''
}

const HubSpotUtk = {
  mounted() {
    this.lastPushedValue = null
    this.hubSpotUtkSyncTimer = null
    this.marketingConsentGranted =
      Boolean(window.OSANO_DISABLED) || hasConsent(OSANO_CATEGORY.MARKETING)

    if (this.marketingConsentGranted) {
      this.startHubSpotUtkSync()
    }

    this.unsubscribeFromConsent = onConsentChange(consent => {
      this.handleConsentChange(consent)
    })
  },

  reconnected() {
    this.marketingConsentGranted =
      Boolean(window.OSANO_DISABLED) || hasConsent(OSANO_CATEGORY.MARKETING)

    if (this.marketingConsentGranted) {
      // Reconcile the old process before resetting deduplication, then force a
      // fresh push for a newly mounted server process.
      this.pushCurrentHubSpotUtk()
      this.lastPushedValue = null
      this.startHubSpotUtkSync()
    } else {
      this.stopHubSpotUtkSync()
      this.clearCurrentHubSpotUtk()
    }
  },

  destroyed() {
    this.stopHubSpotUtkSync()
    this.unsubscribeFromConsent?.()
  },

  handleConsentChange(consent) {
    this.marketingConsentGranted =
      Boolean(window.OSANO_DISABLED) || Boolean(consent[OSANO_CATEGORY.MARKETING])

    if (this.marketingConsentGranted) {
      this.startHubSpotUtkSync()
    } else {
      this.stopHubSpotUtkSync()
      this.clearCurrentHubSpotUtk()
    }
  },

  startHubSpotUtkSync() {
    this.stopHubSpotUtkSync()
    this.syncHubSpotUtk(0)
  },

  syncHubSpotUtk(attempt) {
    if (!this.marketingConsentGranted || this.pushCurrentHubSpotUtk()) return
    if (attempt >= HUBSPOT_UTK_RETRY_DELAYS_MS.length) return

    this.hubSpotUtkSyncTimer = window.setTimeout(() => {
      this.hubSpotUtkSyncTimer = null
      this.syncHubSpotUtk(attempt + 1)
    }, HUBSPOT_UTK_RETRY_DELAYS_MS[attempt])
  },

  stopHubSpotUtkSync() {
    if (this.hubSpotUtkSyncTimer !== null) {
      window.clearTimeout(this.hubSpotUtkSyncTimer)
      this.hubSpotUtkSyncTimer = null
    }
  },

  clearCurrentHubSpotUtk() {
    if (this.lastPushedValue) {
      this.pushEvent('hubspot_utk', {})
    }

    this.lastPushedValue = null
  },

  pushCurrentHubSpotUtk() {
    const value = readHubSpotUtk()

    if (!value) {
      this.clearCurrentHubSpotUtk()
      return false
    }

    if (value !== this.lastPushedValue) {
      this.lastPushedValue = value
      this.pushEvent('hubspot_utk', { value })
    }

    return true
  },
}

export default HubSpotUtk
